/** @ngInject */
export default function graphsRouter($stateProvider) {
    const baseState = {
        url: '/sensors-and-connectors/graphs',
        component: 'dtGraphs'
    };

    $stateProvider
        .state('main.sensors.graphs', baseState);
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/graphs/graphs.router.js